import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Button from '../components/ui/Button';

const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 1, delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default function Contact() {
  const BOOKING_URL = "https://link.nordiccrm.ca/widget/bookings/dorman-ernest-baltazar-personal-calendar-qg2bbc8wa";

  useEffect(() => {
    // Inject the GoHighLevel form script
    const script = document.createElement('script');
    script.src = "https://link.nordiccrm.ca/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script on unmount if necessary
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="w-full bg-kin-black min-h-screen">
      {/* ---------------------------------------------------------------------- */}
      {/* DISCOVERY CALL SECTION (STRICTLY MAINTAINED) */}
      {/* ---------------------------------------------------------------------- */}
      <section className="relative pt-48 pb-20 px-6 overflow-hidden text-center">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[60vw] h-[60vh] bg-kin-gold/5 blur-[120px] rounded-full pointer-events-none"></div>
        <div className="max-w-4xl mx-auto relative z-10">
          <FadeUp>
            <p className="text-kin-gold tracking-[0.4em] text-xs uppercase font-light mb-8"> Connect With The Studio </p>
            <h1 className="text-4xl md:text-7xl font-serif text-kin-ivory mb-16 leading-tight"> 
              Let's Architect Your <br/> <span className="italic text-kin-gold">Next Chapter.</span> 
            </h1>
          </FadeUp>

          <FadeUp delay={0.2} className="bg-[#09090b] border border-kin-ivory/5 p-12 md:p-20 mb-20 max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-serif text-kin-ivory mb-6">Start With A Discovery Call</h2>
            <p className="text-kin-ivory/50 font-light leading-relaxed mb-10 text-lg"> 
              The best way to explore working together is through a focused discovery conversation. Discuss your vision, challenges, and goals directly with Dorman. 
            </p>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" className="px-16 py-6 text-sm"> Book A Discovery Call </Button>
            </a>
          </FadeUp>
        </div>
      </section>

      {/* ---------------------------------------------------------------------- */}
      {/* GENERAL INQUIRIES SECTION (UPDATED WITH GHL EMBED) */}
      {/* ---------------------------------------------------------------------- */}
      <section className="pb-32 px-6 relative z-10">
        <div className="max-w-[900px] mx-auto w-full text-center">
          <FadeUp delay={0.3}>
            <h2 className="text-3xl md:text-4xl font-serif text-kin-ivory mb-6">General Inquiries</h2>
            <p className="max-w-2xl mx-auto text-kin-ivory/50 font-light leading-relaxed mb-12 text-lg">
              Have a question about our resources, speaking engagements, partnerships, media production services, or creative collaborations? 
              Complete the form below and our team will respond as soon as possible.
            </p>
          </FadeUp>

          <FadeUp delay={0.4} className="w-full">
            <div className="contact-form-wrapper w-full bg-[#09090b] border border-kin-ivory/5 rounded-lg overflow-hidden p-4 md:p-8 shadow-2xl">
              <iframe
                src="https://link.nordiccrm.ca/widget/form/TCq85Uh6omefLH4hsuWB"
                style={{ width: "100%", height: "500px", border: "none", borderRadius: "8px" }}
                id="inline-TCq85Uh6omefLH4hsuWB"
                data-layout="{'id':'INLINE'}"
                data-trigger-type="alwaysShow"
                data-trigger-value=""
                data-activation-type="alwaysActivated"
                data-activation-value=""
                data-deactivation-type="neverDeactivate"
                data-deactivation-value=""
                data-form-name="Kingdom form"
                data-height="434"
                data-layout-iframe-id="inline-TCq85Uh6omefLH4hsuWB"
                data-form-id="TCq85Uh6omefLH4hsuWB"
                title="Kingdom form"
              ></iframe>
            </div>
          </FadeUp>
        </div>
      </section>
    </div>
  );
}